import { getSortedPupils } from './pupils-component.selectors'

const setPupilSelectStatus = (id, status) => ({
  type: 'PUPILS_COMPONENT:SET_SELECT_STATUS',
  id,
  status
})

const setPupilSelectStatuses = statuses => ({
  type: 'PUPILS_COMPONENT:SET_SELECT_STATUSES',
  statuses
})

const selectAllPupils = () => (dispatch, getState) => {
  const pupils = getSortedPupils(getState())
  const statuses = {}
  pupils.forEach(pupil => (statuses[pupil.account.id] = true))
  dispatch(setPupilSelectStatuses(statuses))
}

const deselectAllPupils = () => dispatch => dispatch(setPupilSelectStatuses({}))

const changeSortKey = (key, direction) => ({
  type: 'PUPILS_COMPONENT:SET_SORT_KEY',
  key,
  direction
})

const searchValueChange = value => ({
  type: 'PUPILS_COMPONENT:CHANGE_SEARCH_VALUE',
  value
})

const showFilterDialog = () => ({ type: 'PUPILS_COMPONENT:SHOW_FILTER_DIALOG' })

const hideFilterDialog = () => ({ type: 'PUPILS_COMPONENT:HIDE_FILTER_DIALOG' })

const resetFilter = () => ({ type: 'PUPILS_COMPONENT:RESET_FILTER' })

const resetAllFilters = () => ({ type: 'PUPILS_COMPONENT:RESET_ALL_FILTERS' })

const applyGroupsFilter = selectedGroups => ({
  type: 'PUPILS_COMPONENT:APPLY_GROUPS_FILTER',
  selectedGroups
})

const loadMorePupils = () => ({ type: 'PUPILS_COMPONENT:LOAD_MORE' })

const showSelected = () => ({ type: 'PUPILS_COMPONENT:SHOW_SELECTED' })

const unsetShowSelected = () => ({
  type: 'PUPILS_COMPONENT:UNSET_SHOW_SELECTED'
})

const changeGroupsCategory = category => ({
  type: 'PUPILS_COMPONENT:CHANGE_GROUP_CATEGORY',
  category
})

export {
  showSelected,
  unsetShowSelected,
  setPupilSelectStatus,
  selectAllPupils,
  deselectAllPupils,
  changeSortKey,
  searchValueChange,
  showFilterDialog,
  hideFilterDialog,
  resetFilter,
  applyGroupsFilter,
  loadMorePupils,
  changeGroupsCategory,
  resetAllFilters
}
